/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWorkbookRequestDto
 */
export interface CreateWorkbookRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookRequestDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookRequestDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkbookRequestDto
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkbookRequestDto
     */
    requireLogin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookRequestDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookRequestDto
     */
    passwordHint?: string | null;
}

/**
 * Check if a given object implements the CreateWorkbookRequestDto interface.
 */
export function instanceOfCreateWorkbookRequestDto(value: object): value is CreateWorkbookRequestDto {
    return true;
}

export function CreateWorkbookRequestDtoFromJSON(json: any): CreateWorkbookRequestDto {
    return CreateWorkbookRequestDtoFromJSONTyped(json, false);
}

export function CreateWorkbookRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkbookRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'requireLogin': json['requireLogin'] == null ? undefined : json['requireLogin'],
        'password': json['password'] == null ? undefined : json['password'],
        'passwordHint': json['passwordHint'] == null ? undefined : json['passwordHint'],
    };
}

export function CreateWorkbookRequestDtoToJSON(json: any): CreateWorkbookRequestDto {
    return CreateWorkbookRequestDtoToJSONTyped(json, false);
}

export function CreateWorkbookRequestDtoToJSONTyped(value?: CreateWorkbookRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'isPublic': value['isPublic'],
        'requireLogin': value['requireLogin'],
        'password': value['password'],
        'passwordHint': value['passwordHint'],
    };
}

